<template>
  <div class="vacancy-company-logo-name relative" :class="{_employer: isEmployer}">
    <div v-if="showEmployerCompanyTypeAlert" class="vacancy-card-small__recruiting-agency-alert">
      {{ $tVacancy('intermediary_agency') }}
    </div>

    <div class="vacancy-company-logo-name__logo">
      <picture v-if="isEmployer && employerProfile && employerProfile.company_logo"
               class="vacancy-company-logo-name__logo-img">
        <source v-if="vacancy.employer.employerProfile.company_logo_webp"
                :srcset="vacancy.employer.employerProfile.company_logo_webp"
                type="image/webp">
        <img :src="vacancy.employer.employerProfile.company_logo">
      </picture>
      <FileShow v-else-if="!isEmployer && vacancy[3].company_logo"
                :value="vacancy[3].company_logo"
                only-show
                class="vacancy-company-logo-name__logo-img"/>
      <div v-else
           class="vacancy-company-logo-name__logo-placeholder">
      </div>
    </div>
    <div class="vacancy-company-logo-name__name" v-if="isEmployer">
      <span
        class="vacancy-company-logo-name__name-label">{{
          $tVacancy('The employer in this vacancy is a company')
        }}</span>
      <span v-if="employerProfile && employerProfile.name"
            class="vacancy-company-logo-name__name-link">
        <abbr :title="vacancy.employer.employerProfile.name">{{
            vacancy.employer.employerProfile.short_name || vacancy.employer.employerProfile.name
          }}</abbr>
        <BaseSvg name="ico-check-outline"
                 class="vacancy-company-logo-name__name-link-badge"/>
      </span>
      <abbr v-else>{{ $tVacancy('No name') }}</abbr>
    </div>
    <div class="vacancy-company-logo-name__name" v-else>
      {{ vacancy[3].work_place_name || vacancy[3].work_place_code || $tVacancy('No name') }}
    </div>

    <div
      v-if="showEmployerCompanyTypeAlert"
      class="pl-3 pr-3 pt-2 pb-2 text-red"
    >
      <span>{{ $tVacancy('can_be_additional_fees') }}</span>
    </div>
  </div>
</template>

<script>
  import FileShow from '@/components/FileShow'

  export default {
    name: 'VacancyCompanyLogoName',
    components: {FileShow},
    props: {
      vacancy: null,
      isEmployer: {
        type: Boolean
      },
      showEmployerCompanyTypeAlert: {
        type: Boolean,
        default: false,
      },
    },
    data(vm) {
      return {
        employerProfile: vm.vacancy.employer.employerProfile
      }
    },
  }
</script>

<style lang="less">

</style>
